<h1 mat-dialog-title>Settings</h1>

<div mat-dialog-content>
  <form [formGroup]="settingsForm" novalidate (ngSubmit)="(false)">
    <div class="row">
      <div class="col-md-4 col-xs-12 col-sm-12">
        <div class="row">
          <div class="col-md-12">
            <b>Foreground</b>
          </div>
          <div class="col-md-6">Pernament Line Height</div>
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <input
                (click)="$event.target.select()"
                matInput
                type="text"
                formControlName="pernamentLineHeight"
                class="text-right"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">Intermediary Line Height</div>
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <input
                (click)="$event.target.select()"
                matInput
                type="text"
                formControlName="intermediateLineHeight"
                class="text-right"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">Pernament Line Width</div>
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <input
                (click)="$event.target.select()"
                matInput
                type="text"
                formControlName="pernamentLineWidth"
                class="text-right"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">Number of Waves</div>
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <input
                (click)="$event.target.select()"
                matInput
                type="text"
                formControlName="numberOfWaves"
                class="text-right"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">Total Number of Waves</div>
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <input
                (click)="$event.target.select()"
                matInput
                type="text"
                formControlName="totalNumberOfWaves"
                class="text-right"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-12 p-0">
            <b>Background</b>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 p-0">Pernament Line Height</div>
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <input
                (click)="$event.target.select()"
                matInput
                type="text"
                formControlName="pernamentLineHeightOverlay"
                class="text-right"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 p-0">Intermediary Line Height</div>
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <input
                (click)="$event.target.select()"
                matInput
                type="text"
                formControlName="intermediateLineHeightOverlay"
                class="text-right"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 p-0">Pernament Line Width</div>
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <input
                (click)="$event.target.select()"
                matInput
                type="text"
                formControlName="pernamentLineWidthOverlay"
                class="text-right"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 p-0">Number of Waves</div>
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <input
                (click)="$event.target.select()"
                matInput
                type="text"
                formControlName="numberOfWavesOverlay"
                class="text-right"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 p-0">Total Number of Waves</div>
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <input
                (click)="$event.target.select()"
                matInput
                type="text"
                formControlName="totalNumberOfWavesOverlay"
                class="text-right"
              />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="row">
          <div class="col-md-12">
            <b>Moving Average Settings</b>
          </div>
          <div class="col-md-6">Grey Line Min</div>
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <input
                (click)="$event.target.select()"
                matInput
                type="text"
                formControlName="smaGreyLineMin"
                class="text-right"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">Purple Line Min</div>
          <div class="col-md-4">
            <mat-form-field class="w-100">
              <input
                (click)="$event.target.select()"
                matInput
                type="text"
                formControlName="smaPurpleLineMin"
                class="text-right"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onDismiss()">No</button>
  <button mat-raised-button [color]="'glb_greenbtn'" (click)="onConfirm()">
    OK
  </button>
</div>
